import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import PlayerActionsBar from './PlayerActionsBar';
import type { PlayerActionsBarProps, PlayerActionsBarAPI, PlayerActionsBarHandle } from './types';

declare global {
  interface Window {
    mountPlayerActionsBar: (containerId: string, props: PlayerActionsBarProps) => PlayerActionsBarHandle;
  }
}

window.mountPlayerActionsBar = function mountPlayerActionsBar(
  containerId: string,
  props: PlayerActionsBarProps,
): PlayerActionsBarHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('PlayerActionsBar: container not found:', containerId);
    return { unmount: () => {}, get api() { return null; } };
  }

  const apiRef = createRef<PlayerActionsBarAPI>();
  const root = createRoot(container);
  root.render(React.createElement(PlayerActionsBar, { ...props, ref: apiRef }));

  return {
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};
